import { fetchWithReauth } from '../utils/auth';
import {
  BodyZoneApi,
  BoneTagApi,
  EquipmentApi,
  ExerciseApi,
  FileApi,
  MaintenanceApi,
  MuscleTagApi,
  OCRApi,
  PlanApi,
  DeckApi,
  StripeApi,
  TraineeManagementApi,
  TrainingHistoryApi,
  UserApi,
  GlossaryApi,
  ExerciseCategoryApi,
  ExerciseFactApi,
} from './apis';
import { Configuration } from './runtime';

export const apiBasePath = `${process.env.REACT_APP_PUBLIC_URL}${process.env.REACT_APP_API_PATH}`;

const loggedInConfiguration = new Configuration({
  fetchApi: fetchWithReauth,
  basePath: apiBasePath,
});

export const bodyZoneApi = new BodyZoneApi(loggedInConfiguration);
export const stripeApi = new StripeApi(loggedInConfiguration);
export const exerciseApi = new ExerciseApi(loggedInConfiguration);
export const exerciseCategoryApi = new ExerciseCategoryApi(loggedInConfiguration);
export const fileApi = new FileApi(loggedInConfiguration);
export const boneTagApi = new BoneTagApi(loggedInConfiguration);
export const muscleTagApi = new MuscleTagApi(loggedInConfiguration);
export const ocrApi = new OCRApi(loggedInConfiguration);
export const deckApi = new DeckApi(loggedInConfiguration);
export const userApi = new UserApi(loggedInConfiguration);
export const equipmentApi = new EquipmentApi(loggedInConfiguration);
export const planApi = new PlanApi(loggedInConfiguration);
export const traineeApi = new TraineeManagementApi(loggedInConfiguration);
export const maintenanceApi = new MaintenanceApi(loggedInConfiguration);
export const trainingHistoryApi = new TrainingHistoryApi(loggedInConfiguration);
export const glossaryApi = new GlossaryApi(loggedInConfiguration);
export const exerciseFactsApi = new ExerciseFactApi(loggedInConfiguration);
